import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "legend-list",
  class: "legend-list"
}
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・過去-計測１時間(Q-8-2) ", -1)
const _hoisted_6 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "200(台)以下", -1)
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "201～500(台)", -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, "501～1,000(台)", -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", null, "1,001～2,000(台)", -1)
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", null, "2,001～4,000(台)", -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", null, "4,001(台)以上", -1)
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・過去-計測１時間(QA-8-2) ", -1)
const _hoisted_23 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", null, "200(台)以下", -1)
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", null, "201～500(台)", -1)
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", null, "501～1,000(台)", -1)
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("th", null, "1,001～2,000(台)", -1)
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", null, "2,001～4,000(台)", -1)
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", null, "4,001(台)以上", -1)
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_38 = { key: 2 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・最新-計測５分(Q-8-1) ", -1)
const _hoisted_40 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_41 = ["src"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("th", null, "20(台)以下", -1)
const _hoisted_43 = ["src"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("th", null, "21～50(台)", -1)
const _hoisted_45 = ["src"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("th", null, "51～100(台)", -1)
const _hoisted_47 = ["src"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("th", null, "101～200(台)", -1)
const _hoisted_49 = ["src"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("th", null, "201～400(台)", -1)
const _hoisted_51 = ["src"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("th", null, "401(台)以上", -1)
const _hoisted_53 = ["src"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_55 = { key: 3 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・最新-計測５分(QA-8-1) ", -1)
const _hoisted_57 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_58 = ["src"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("th", null, "20(台)以下", -1)
const _hoisted_60 = ["src"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("th", null, "21～50(台)", -1)
const _hoisted_62 = ["src"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("th", null, "51～100(台)", -1)
const _hoisted_64 = ["src"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("th", null, "101～200(台)", -1)
const _hoisted_66 = ["src"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("th", null, "201～400(台)", -1)
const _hoisted_68 = ["src"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("th", null, "401(台)以上", -1)
const _hoisted_70 = ["src"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_72 = { key: 4 }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・最新-計測１時間(Q-8-2) ", -1)
const _hoisted_74 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_75 = ["src"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("th", null, "200(台)以下", -1)
const _hoisted_77 = ["src"]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("th", null, "201～500(台)", -1)
const _hoisted_79 = ["src"]
const _hoisted_80 = /*#__PURE__*/_createElementVNode("th", null, "501～1,000(台)", -1)
const _hoisted_81 = ["src"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("th", null, "1,001～2,000(台)", -1)
const _hoisted_83 = ["src"]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("th", null, "2,001～4,000(台)", -1)
const _hoisted_85 = ["src"]
const _hoisted_86 = /*#__PURE__*/_createElementVNode("th", null, "4,001(台)以上", -1)
const _hoisted_87 = ["src"]
const _hoisted_88 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_89 = { key: 5 }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・最新-計測１時間(QA-8-2) ", -1)
const _hoisted_91 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_92 = ["src"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("th", null, "200(台)以下", -1)
const _hoisted_94 = ["src"]
const _hoisted_95 = /*#__PURE__*/_createElementVNode("th", null, "201～500(台)", -1)
const _hoisted_96 = ["src"]
const _hoisted_97 = /*#__PURE__*/_createElementVNode("th", null, "501～1,000(台)", -1)
const _hoisted_98 = ["src"]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("th", null, "1,001～2,000(台)", -1)
const _hoisted_100 = ["src"]
const _hoisted_101 = /*#__PURE__*/_createElementVNode("th", null, "2,001～4,000(台)", -1)
const _hoisted_102 = ["src"]
const _hoisted_103 = /*#__PURE__*/_createElementVNode("th", null, "4,001(台)以上", -1)
const _hoisted_104 = ["src"]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_106 = { key: 6 }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・道路種別 ", -1)
const _hoisted_108 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_109 = { class: "pre-wrap" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・車線数 ", -1)
const _hoisted_111 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・昼間12時間交通量（全車・上下計） ", -1)
const _hoisted_113 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・24時間交通量（全車・上下計） ", -1)
const _hoisted_115 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・混雑度 ", -1)
const _hoisted_117 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・朝夕旅行速度/昼間旅行速度 ", -1)
const _hoisted_119 = { key: 7 }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・時間帯別交通量 ", -1)
const _hoisted_121 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_122 = { key: 8 }
const _hoisted_123 = { class: "legend-list__group-title legend-list__group-title_top" }
const _hoisted_124 = ["src"]
const _hoisted_125 = /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, [
  /*#__PURE__*/_createTextVNode(" ・高速自動車道"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・一般国道（NEXCO東日本・中日本・西日本/首都高・阪高・本四高速）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・一般都道府県道（NEXCO東日本・中日本・西日本） ")
], -1)
const _hoisted_126 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level1" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "80(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level2" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "60～79(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level3" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "50～59(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level4" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40～49(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level5" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level6" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～19(km/h)")
    ])
  ])
], -1)
const _hoisted_127 = { class: "legend-list__group-title legend-list__group-title_top" }
const _hoisted_128 = ["src"]
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, [
  /*#__PURE__*/_createTextVNode(" ・都市高速道路"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・一般国道（道路公社）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・主要地方道（都道府県道）（道路公社）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・一般都道府県道（道路公社）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・指定市の一般市道（首都高・阪高・本四高速/道路公社） ")
], -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level1" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "60(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level2" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40～59(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level3" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "30～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level4" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～29(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level5" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "10～19(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level6" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～9(km/h)")
    ])
  ])
], -1)
const _hoisted_131 = { class: "legend-list__group-title legend-list__group-title_top" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_133 = ["src"]
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, [
  /*#__PURE__*/_createTextVNode(" ・一般国道（その他の管理者コード）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・主要地方道（都道府県道）（その他の管理者コード）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・主要地方道（指定市市道）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・一般都道府県道（その他の管理者コード）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・指定市の一般市道（その他の管理者コード）"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level7" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level8" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level9" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "15～19(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level10" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "10～14(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level11" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "5～9(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level12" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～4(km/h)")
    ])
  ])
], -1)
const _hoisted_136 = { key: 9 }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・都市間高速道路 ", -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level1" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "80(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level2" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "60～79(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level3" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "50～59(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level4" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40～49(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level5" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level6" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～19(km/h)")
    ])
  ])
], -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・都市内高速道路 ", -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level1" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "60(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level2" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40～59(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level3" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "30～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level4" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～29(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level5" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "10～19(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level6" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～9(km/h)")
    ])
  ])
], -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・一般道 ", -1)
const _hoisted_142 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level7" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level8" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level9" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "15～19(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level10" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "10～14(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level11" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "5～9(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level12" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～4(km/h)")
    ])
  ])
], -1)
const _hoisted_143 = [
  _hoisted_137,
  _hoisted_138,
  _hoisted_139,
  _hoisted_140,
  _hoisted_141,
  _hoisted_142
]
const _hoisted_144 = { key: 10 }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・色 ", -1)
const _hoisted_146 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_147 = ["src"]
const _hoisted_148 = /*#__PURE__*/_createElementVNode("th", null, "出発点", -1)
const _hoisted_149 = ["src"]
const _hoisted_150 = /*#__PURE__*/_createElementVNode("th", null, "到着点", -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・出発点の円の大きさ ", -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "10px"),
      /*#__PURE__*/_createElementVNode("th", null, "199,999以下")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "20px"),
      /*#__PURE__*/_createElementVNode("th", null, "200,000～399,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "30px"),
      /*#__PURE__*/_createElementVNode("th", null, "400,000～599,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "40px"),
      /*#__PURE__*/_createElementVNode("th", null, "600,000～799,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "50px"),
      /*#__PURE__*/_createElementVNode("th", null, "800,000～999,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "60px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,000,000～1,199,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "70px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,200,000～1,399,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "80px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,400,000～1,599,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "90px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,600,000～1,799,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "100px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,800,000以上")
    ])
  ])
], -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・到着点の円の大きさ ", -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "10px"),
      /*#__PURE__*/_createElementVNode("th", null, "1.0％以下")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "20px"),
      /*#__PURE__*/_createElementVNode("th", null, "1.1～2.0％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "30px"),
      /*#__PURE__*/_createElementVNode("th", null, "2.1～3.0％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "40px"),
      /*#__PURE__*/_createElementVNode("th", null, "3.1～4.0％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "50px"),
      /*#__PURE__*/_createElementVNode("th", null, "4.1～5.0％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "60px"),
      /*#__PURE__*/_createElementVNode("th", null, "5.1～6.0％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "70px"),
      /*#__PURE__*/_createElementVNode("th", null, "6.1～7.0％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "80px"),
      /*#__PURE__*/_createElementVNode("th", null, "7.1～8.0％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "90px"),
      /*#__PURE__*/_createElementVNode("th", null, "8.1～9.0％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "100px"),
      /*#__PURE__*/_createElementVNode("th", null, "9.1％以上")
    ])
  ])
], -1)
const _hoisted_155 = { key: 11 }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・色 ", -1)
const _hoisted_157 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_158 = ["src"]
const _hoisted_159 = /*#__PURE__*/_createElementVNode("th", null, "発生・集中量", -1)
const _hoisted_160 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・円の大きさ ", -1)
const _hoisted_161 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "10px"),
      /*#__PURE__*/_createElementVNode("th", null, "199,999以下")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "20px"),
      /*#__PURE__*/_createElementVNode("th", null, "200,000～399,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "30px"),
      /*#__PURE__*/_createElementVNode("th", null, "400,000～599,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "40px"),
      /*#__PURE__*/_createElementVNode("th", null, "600,000～799,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "50px"),
      /*#__PURE__*/_createElementVNode("th", null, "800,000～999,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "60px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,000,000～1,199,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "70px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,200,000～1,399,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "80px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,400,000～1,599,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "90px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,600,000～1,799,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "100px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,800,000以上")
    ])
  ])
], -1)
const _hoisted_162 = { key: 12 }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・点検DB ", -1)
const _hoisted_164 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_165 = ["src"]
const _hoisted_166 = /*#__PURE__*/_createElementVNode("th", null, "道路橋", -1)
const _hoisted_167 = ["src"]
const _hoisted_168 = /*#__PURE__*/_createElementVNode("th", null, "トンネル", -1)
const _hoisted_169 = ["src"]
const _hoisted_170 = /*#__PURE__*/_createElementVNode("th", null, "シェッド", -1)
const _hoisted_171 = ["src"]
const _hoisted_172 = /*#__PURE__*/_createElementVNode("th", null, "大型カルバート", -1)
const _hoisted_173 = ["src"]
const _hoisted_174 = /*#__PURE__*/_createElementVNode("th", null, "横断歩道橋", -1)
const _hoisted_175 = ["src"]
const _hoisted_176 = /*#__PURE__*/_createElementVNode("th", null, "門型標識等", -1)
const _hoisted_177 = ["src"]
const _hoisted_178 = /*#__PURE__*/_createElementVNode("th", null, "舗装", -1)
const _hoisted_179 = ["src"]
const _hoisted_180 = /*#__PURE__*/_createElementVNode("th", null, "特定道路土工構造物", -1)
const _hoisted_181 = { key: 13 }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・事故内容 ", -1)
const _hoisted_183 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", { class: "legend-list__accident_hotspot legend-list__accident_hotspot_death" }, " × "),
      /*#__PURE__*/_createElementVNode("th", null, "死亡")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", { class: "legend-list__accident_hotspot legend-list__accident_hotspot_injury" }, " × "),
      /*#__PURE__*/_createElementVNode("th", null, "負傷")
    ])
  ])
], -1)
const _hoisted_184 = [
  _hoisted_182,
  _hoisted_183
]
const _hoisted_185 = { key: 14 }
const _hoisted_186 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・ロードキル発生状況 ", -1)
const _hoisted_187 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_188 = ["src"]
const _hoisted_189 = /*#__PURE__*/_createElementVNode("th", null, "全データ", -1)
const _hoisted_190 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_roadkill_heatmap" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "legend-list__label legend-list__label_roadkill_heatmap_low" }, "事故:少"),
      /*#__PURE__*/_createElementVNode("span", { class: "legend-list__label legend-list__label_roadkill_heatmap_high" }, "事故:多")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("th", null, "ヒートマップ")
], -1)
const _hoisted_191 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・対策実施状況 ", -1)
const _hoisted_192 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_193 = ["src"]
const _hoisted_194 = /*#__PURE__*/_createElementVNode("th", null, "警戒標識", -1)
const _hoisted_195 = ["src"]
const _hoisted_196 = /*#__PURE__*/_createElementVNode("th", null, "路面表示", -1)
const _hoisted_197 = ["src"]
const _hoisted_198 = /*#__PURE__*/_createElementVNode("th", null, "道路横断施設", -1)
const _hoisted_199 = ["src"]
const _hoisted_200 = /*#__PURE__*/_createElementVNode("th", null, "注意看板", -1)
const _hoisted_201 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_roadkill_cm_fence" })
  ]),
  /*#__PURE__*/_createElementVNode("th", null, "柵・フェンス")
], -1)
const _hoisted_202 = ["src"]
const _hoisted_203 = /*#__PURE__*/_createElementVNode("th", null, "道路情報板", -1)
const _hoisted_204 = ["src"]
const _hoisted_205 = /*#__PURE__*/_createElementVNode("th", null, "移動式注意喚起看板", -1)
const _hoisted_206 = ["src"]
const _hoisted_207 = /*#__PURE__*/_createElementVNode("th", null, "その他（点データ）", -1)
const _hoisted_208 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_roadkill_cm_other" })
  ]),
  /*#__PURE__*/_createElementVNode("th", null, "その他（線データ）")
], -1)
const _hoisted_209 = { key: 15 }
const _hoisted_210 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・主要渋滞箇所 ", -1)
const _hoisted_211 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_212 = ["src"]
const _hoisted_213 = /*#__PURE__*/_createElementVNode("th", null, "主要渋滞箇所", -1)
const _hoisted_214 = { key: 16 }
const _hoisted_215 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・重要物流道路 ", -1)
const _hoisted_216 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_217 = ["src"]
const _hoisted_218 = /*#__PURE__*/_createElementVNode("th", null, "全国重要物流道路", -1)
const _hoisted_219 = ["src"]
const _hoisted_220 = /*#__PURE__*/_createElementVNode("th", null, "全国代替補完路", -1)
const _hoisted_221 = { key: 17 }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・重さ・高さ指定道路 ", -1)
const _hoisted_223 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_sub" }, " ・重さ指定道路 高さ指定道路 ", -1)
const _hoisted_224 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table legend-list__group-table_part",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_auxiliary_wh" })
      ]),
      /*#__PURE__*/_createElementVNode("th", { class: "legend-list__multiline" }, [
        /*#__PURE__*/_createTextVNode(" 一般国道（補助区間）"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("都道府県・市区町村 ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_auxiliary_wh legend-list__line_special_vehicle_directly" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般国道（直轄区間）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_urban_wh" })
      ]),
      /*#__PURE__*/_createElementVNode("th", { class: "legend-list__multiline" }, [
        /*#__PURE__*/_createTextVNode(" 都市高速道路"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("その他の有料道路 ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_urban_wh legend-list__line_special_vehicle_expressway" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路")
    ])
  ])
], -1)
const _hoisted_225 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_sub" }, " ・重さ指定道路 ", -1)
const _hoisted_226 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table legend-list__group-table_part",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_auxiliary_weight" })
      ]),
      /*#__PURE__*/_createElementVNode("th", { class: "legend-list__multiline" }, [
        /*#__PURE__*/_createTextVNode(" 一般国道（補助区間）"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("都道府県・市区町村 ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_auxiliary_weight legend-list__line_special_vehicle_directly" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般国道（直轄区間）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_urban_weight" })
      ]),
      /*#__PURE__*/_createElementVNode("th", { class: "legend-list__multiline" }, [
        /*#__PURE__*/_createTextVNode(" 都市高速道路"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("その他の有料道路 ")
      ])
    ])
  ])
], -1)
const _hoisted_227 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_sub" }, " ・高さ指定道路 ", -1)
const _hoisted_228 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_auxiliary_height" })
      ]),
      /*#__PURE__*/_createElementVNode("th", { class: "legend-list__multiline" }, [
        /*#__PURE__*/_createTextVNode(" 一般国道（補助区間）"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("都道府県・市区町村 ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_auxiliary_height legend-list__line_special_vehicle_directly" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般国道（直轄区間）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_urban_height" })
      ]),
      /*#__PURE__*/_createElementVNode("th", { class: "legend-list__multiline" }, [
        /*#__PURE__*/_createTextVNode(" 都市高速道路"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("その他の有料道路 ")
      ])
    ])
  ])
], -1)
const _hoisted_229 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・大型車誘導区間 ", -1)
const _hoisted_230 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_guidance" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "大型車誘導区間")
    ])
  ])
], -1)
const _hoisted_231 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・特車通行許可不要区間 ", -1)
const _hoisted_232 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_special_vehicle_exempt" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "特車通行許可不要区間")
    ])
  ])
], -1)
const _hoisted_233 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・特車通行許可不要区間（交差点） ", -1)
const _hoisted_234 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_235 = ["src"]
const _hoisted_236 = /*#__PURE__*/_createElementVNode("th", null, "C条件あり", -1)
const _hoisted_237 = ["src"]
const _hoisted_238 = /*#__PURE__*/_createElementVNode("th", null, "通行不可あり", -1)
const _hoisted_239 = { key: 18 }
const _hoisted_240 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・リンク ", -1)
const _hoisted_241 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路（国道有料区間）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路（国道無料区間）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "都市高速道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_red" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般国道（指定区間該当）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_red" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般国道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_yellow" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "主要地方道[都道府県道]")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_orange" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "主要地方道[指定市道]")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_yellow" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般都道府県道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "指定市の一般市道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "基本道路：その他道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "基本道路：未調査")
    ])
  ])
], -1)
const _hoisted_242 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・ノード ", -1)
const _hoisted_243 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_244 = ["src"]
const _hoisted_245 = /*#__PURE__*/_createElementVNode("th", null, "ノード", -1)
const _hoisted_246 = { key: 19 }
const _hoisted_247 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・リンク ", -1)
const _hoisted_248 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路（国道有料区間）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路（国道無料区間）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "都市高速道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_red" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般国道（指定区間該当）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_red" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般国道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_yellow" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "主要地方道[都道府県道]")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_orange" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "主要地方道[指定市道]")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_yellow" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般都道府県道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "指定市の一般市道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "基本道路：その他道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "基本道路：未調査")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "細道路：その他道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "細道路：未調査")
    ])
  ])
], -1)
const _hoisted_249 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・ノード ", -1)
const _hoisted_250 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_251 = ["src"]
const _hoisted_252 = /*#__PURE__*/_createElementVNode("th", null, "ノード", -1)

import { SelectItem, Tooltip } from "@/components/modules";
import { ref } from "vue";
import level1LayerIcon from "@/../public/icon/layer/point_level1.png";
import level2LayerIcon from "@/../public/icon/layer/point_level2.png";
import level3LayerIcon from "@/../public/icon/layer/point_level3.png";
import level4LayerIcon from "@/../public/icon/layer/point_level4.png";
import level5LayerIcon from "@/../public/icon/layer/point_level5.png";
import level6LayerIcon from "@/../public/icon/layer/point_level6.png";
import loadkillOccurrenceLayerIcon from "@/../public/icon/layer/point_loadkill.png";
import loadkillWarningSignLayerIcon from "@/../public/icon/layer/point_roadkill_cm_warning_sign.png";
import loadkillSignboardLayerIcon from "@/../public/icon/layer/point_roadkill_cm_signboard.png";
import loadkillRoadMarkingLayerIcon from "@/../public/icon/layer/point_roadkill_cm_road_marking.png";
import loadkillInformationBoardLayerIcon from "@/../public/icon/layer/point_roadkill_cm_information_board.png";
import loadkillUnderpassLayerIcon from "@/../public/icon/layer/point_roadkill_cm_underpass.png";
import loadkillPortableSignLayerIcon from "@/../public/icon/layer/point_roadkill_cm_portable_sign.png";
import loadkillOtherLayerIcon from "@/../public/icon/layer/point_roadkill_cm_other.png";
import specialVehicleXpointExemptLayerIcon from "@/../public/icon/layer/point_special_vehicle_xpoint_exempt.png";
import specialVehicleXpointConditionCLayerIcon from "@/../public/icon/layer/point_special_vehicle_xpoint_condition_c.png";
import majorTrafficCongestionLayerIcon from "@/../public/icon/layer/major_traffic_congestion.png";
import odPointDepartureLayerIcon from "@/../public/icon/layer/od_point_departure.png";
import odPointArrivalLayerIcon from "@/../public/icon/layer/od_point_arrival.png";
import odPointGenerationLayerIcon from "@/../public/icon/layer/od_point_generation.png";
import missingLayerIcon from "@/../public/icon/layer/point_missing.png";
import BridgesLayerIcon from "@/../public/icon/layer/structures-bridges.png";
import TunnelsLayerIcon from "@/../public/icon/layer/structures-tunnels.png";
import ShedsLayerIcon from "@/../public/icon/layer/structures-sheds.png";
import CulvertsLayerIcon from "@/../public/icon/layer/structures-culverts.png";
import PedestrianDecksLayerIcon from "@/../public/icon/layer/structures-pedestrian_decks.png";
import OverheadSignagesLayerIcon from "@/../public/icon/layer/structures-overhead_signages.png";
import PavementsLayerIcon from "@/../public/icon/layer/structures-pavements.png";
import EarthworksLayerIcon from "@/../public/icon/layer/structures-earthworks.png";
import RoadtypeLogisticsLayerIcon from "@/../public/icon/layer/roadtype-logistics.png";
import RoadtypeAlternativeLayerIcon from "@/../public/icon/layer/roadtype-alternative.png";
import QuestionIcon from "@/../public/icon/dialog/info.png";
import { GENERAL_TRAFFIC_ROAD_CATEGORY_LIST } from "@/components/define/defineType";

/**
 * 交通量データサブリスト
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'legend-list',
  setup(__props) {

const SUB_LIST_TRAVOS = [
  {
    key: "travos_history_q82",
    text: "過去-計測１時間(Q-8-2)",
  },
  {
    key: "travos_history_qa82",
    text: "過去-計測１時間(QA-8-2)",
  },
  {
    key: "travos_realtime_q81",
    text: "最新-計測５分(Q-8-1)",
  },
  {
    key: "travos_realtime_qa81",
    text: "最新-計測５分(QA-8-1)",
  },
  {
    key: "travos_realtime_q82",
    text: "最新-計測１時間(Q-8-2)",
  },
  {
    key: "travos_realtime_qa82",
    text: "最新-計測１時間(QA-8-2)",
  },
];

/**
 * 一般交通量調査データサブリスト
 */
const SUB_LIST_GENERAL_TRAFFIC = [
  { key: "gen_location", text: "箇所別基本表" },
  { key: "gen_time", text: "時間帯別交通量" },
];

/**
 * 一般交通量調査データ箇所別基本表 道路種別
 */
const GEN_LOCATION_ROAD_TYPE = [
  {
    text: "一般都道府県道･\n指定市の一般市道",
    style: "legend-list__line_gen_road_brown",
  },
  {
    text: "主要地方道\n（都道府県道･指定市道）",
    style: "legend-list__line_gen_road_green",
  },
  {
    text: GENERAL_TRAFFIC_ROAD_CATEGORY_LIST[2].text,
    style: "legend-list__line_gen_road_red",
  },
  {
    text: GENERAL_TRAFFIC_ROAD_CATEGORY_LIST[3].text,
    style: "legend-list__line_gen_road_yellow",
  },
  {
    text: GENERAL_TRAFFIC_ROAD_CATEGORY_LIST[4].text,
    style: "legend-list__line_gen_road_navy",
  },
  {
    text: GENERAL_TRAFFIC_ROAD_CATEGORY_LIST[5].text,
    style: "legend-list__line_gen_road_blue",
  },
];

/**
 * 一般交通量調査データ箇所別基本表 車線数
 */
const GEN_LOCATION_LANES = [
  { text: "1車線", style: "legend-list__line_gen_lanes_light-blue" },
  { text: "2～3車線", style: "legend-list__line_gen_lanes_light-green" },
  { text: "4～5車線", style: "legend-list__line_gen_lanes_yellow" },
  { text: "6～7車線", style: "legend-list__line_gen_lanes_orange" },
  { text: "8車線以上", style: "legend-list__line_gen_lanes_red" },
];

/**
 * 一般交通量調査データ箇所別基本表 昼間12時間/24時間交通量 （全車・上下計）
 */
const GEN_LOCATION_HOURS = [
  { text: "2,000（台/hhH)以下", style: "legend-list__line_gen_hours_level1" },
  {
    text: "2,001 ～ 5,000（台/hhH)",
    style: "legend-list__line_gen_hours_level2",
  },
  {
    text: "5,001 ～ 10,000（台/hhH)",
    style: "legend-list__line_gen_hours_level3",
  },
  {
    text: "10,001 ～ 20,000（台/hhH)",
    style: "legend-list__line_gen_hours_level4",
  },
  {
    text: "20,001 ～ 40,000（台/hhH)",
    style: "legend-list__line_gen_hours_level5",
  },
  { text: "40,001（台/hhH)～", style: "legend-list__line_gen_hours_level6" },
];

/**
 * 一般交通量調査データ箇所別基本表 混雑度
 */
const GEN_LOCATION_CONGESTION = [
  { text: "非観測", style: "legend-list__line_gen_congestion_level1" },
  { text: "0.4以下", style: "legend-list__line_gen_congestion_level2" },
  { text: "0.4 ～ 0.6", style: "legend-list__line_gen_congestion_level3" },
  { text: "0.6 ～ 0.8", style: "legend-list__line_gen_congestion_level4" },
  { text: "0.8 ～ 1.0", style: "legend-list__line_gen_congestion_level5" },
  { text: "1.0 ～", style: "legend-list__line_gen_congestion_level6" },
];

/**
 * 一般交通量調査データ箇所別基本表 朝夕旅行速度/昼間旅行速度
 */
const GEN_LOCATION_TRAVEL = [
  {
    title: "都市間高速道路",
    items: [
      { text: "80(km/h)以上", style: "legend-list__line_gen_speed_level1" },
      { text: "60～79(km/h)", style: "legend-list__line_gen_speed_level2" },
      { text: "50～59(km/h)", style: "legend-list__line_gen_speed_level3" },
      { text: "40～49(km/h)", style: "legend-list__line_gen_speed_level4" },
      { text: "20～39(km/h)", style: "legend-list__line_gen_speed_level5" },
      { text: "0～19(km/h)", style: "legend-list__line_gen_speed_level6" },
    ],
  },
  {
    title: "都市内高速道路",
    items: [
      { text: "60(km/h)以上", style: "legend-list__line_gen_speed_level1" },
      { text: "40～59(km/h)", style: "legend-list__line_gen_speed_level2" },
      { text: "30～39(km/h)", style: "legend-list__line_gen_speed_level3" },
      { text: "20～29(km/h)", style: "legend-list__line_gen_speed_level4" },
      { text: "10～19(km/h)", style: "legend-list__line_gen_speed_level5" },
      { text: "0～9(km/h)", style: "legend-list__line_gen_speed_level6" },
    ],
  },
  {
    title: "一般道",
    items: [
      {
        text: "40(km/h)以上",
        style: "legend-list__line_gen_speed_general_level1",
      },
      {
        text: "20～39(km/h)",
        style: "legend-list__line_gen_speed_general_level2",
      },
      {
        text: "15～19(km/h)",
        style: "legend-list__line_gen_speed_general_level3",
      },
      {
        text: "10～14(km/h)",
        style: "legend-list__line_gen_speed_general_level4",
      },
      {
        text: "5～9(km/h)",
        style: "legend-list__line_gen_speed_general_level5",
      },
      {
        text: "0～4(km/h)",
        style: "legend-list__line_gen_speed_general_level6",
      },
    ],
  },
];

/**
 * 一般交通量調査データ時間帯別交通量
 */
const GEN_TIME = [
  { text: "200（台/h)以下", style: "legend-list__line_gen_time_level1" },
  { text: "201～500（台/h)", style: "legend-list__line_gen_time_level2" },
  { text: "501～1,000（台/h)", style: "legend-list__line_gen_time_level3" },
  { text: "1,001～2,000（台/h)", style: "legend-list__line_gen_time_level4" },
  { text: "2,001～4,000（台/h)", style: "legend-list__line_gen_time_level5" },
  { text: "4,000（台/h)～", style: "legend-list__line_gen_time_level6" },
];

/**
 * ETC2.0サブリスト
 */
const SUB_LIST_ETC = [
  {
    key: "etc_drm",
    text: "DRMリンク",
  },
  {
    key: "etc_traffic",
    text: "交通調査基本区間",
  },
];

/**
 * ODサブリスト
 */
const SUB_LIST_OD = [
  { key: "od_traffic_pref", text: "OD交通量-都道府県" },
  { key: "od_generation_pref", text: "発生・集中量-都道府県" },
];

/**
 * 点検DBサブリスト
 */
const SUB_LIST_ROAD_STRUCTURES = [{ key: "road_structures", text: "点検DB" }];

/**
 * 交通事故統計情報サブリスト
 */
const SUB_LIST_ACCIDENT_HOTSPOT = [
  { key: "accident_hotspot", text: "交通事故統計情報" },
];

/**
 * ロードキルサブリスト
 */
const SUB_LIST_ROADKILL = [{ key: "roadkill", text: "ロードキル" }];

/**
 * 道路の指定・特定状況サブリスト
 */
const SUB_LIST_SPECIFIC_SITUATIONS = [
  { key: "major_traffic_congestion", text: "主要渋滞箇所" },
  { key: "important_logistics_road", text: "重要物流道路" },
  { key: "special_vehicle", text: "特殊車両データ" },
];

/**
 * DRM-DBサブリスト
 */
const SUB_LIST_DRM = [
  { key: "drm_basic_road", text: "基本道路" },
  { key: "drm_all_road", text: "全道路" },
];

/**
 * サイドメニューリスト
 */
const MAIN_LIST = {
  travos: { text: "交通量データ", subList: SUB_LIST_TRAVOS },
  generalTraffic: {
    text: "一般交通量調査データ",
    subList: SUB_LIST_GENERAL_TRAFFIC,
  },
  etc: { text: "ETC2.0", subList: SUB_LIST_ETC },
  od: { text: "OD", subList: SUB_LIST_OD },
  roadStructures: { text: "点検DB", subList: SUB_LIST_ROAD_STRUCTURES },
  accidentHotspot: {
    text: "交通事故統計情報",
    subList: SUB_LIST_ACCIDENT_HOTSPOT,
  },
  roadkill: { text: "ロードキル", subList: SUB_LIST_ROADKILL },
  specificSituations: {
    text: "道路の指定・特定状況",
    subList: SUB_LIST_SPECIFIC_SITUATIONS,
  },
  drm: { text: "DRM-DB", subList: SUB_LIST_DRM },
};

/**
 * 選択中サブ項目
 */
const selectedSubListItem = ref(SUB_LIST_TRAVOS[0].key);

/**
 * サブリスト
 */
const subList = ref(SUB_LIST_TRAVOS);

/**
 * ETCスクロール処理
 */
const scrollEtc = () => {
  const legendList = document.getElementById("legend-list");

  const adjust = () => {
    const toolTips = document.querySelectorAll(".help-tooltip");
    const scrollY = legendList.scrollTop;
    toolTips.forEach((ele: any) => {
      ele.style.transform = "translateY(-" + scrollY + "px)";
    });
  };

  setTimeout(() => {
    if (selectedSubListItem.value == SUB_LIST_ETC[0].key) {
      adjust();
      legendList.addEventListener("scroll", () => {
        adjust();
      });
    }
  }, 10);
};

/**
 * メイン項目選択変更
 */
const changeMain = (index: number) => {
  subList.value = Object.values(MAIN_LIST)[index].subList;
  setTimeout(() => {
    selectedSubListItem.value = subList.value[0].key;
    scrollEtc();
  }, 10);
};

/**
 * サブ項目選択変更
 */
const changeSub = (item: string) => {
  selectedSubListItem.value = item;
  scrollEtc();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SelectItem), {
      fontSize: "1.6rem",
      height: "28px",
      onUpdate: _cache[0] || (_cache[0] = 
        (index) => {
          changeMain(index);
        }
      )
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(MAIN_LIST), (ele, index) => {
          return (_openBlock(), _createElementBlock("option", {
            value: index,
            key: Object.keys(MAIN_LIST)[index]
          }, _toDisplayString(ele.text), 9, _hoisted_2))
        }), 128))
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_unref(SelectItem), {
      class: "legend-list__sub-item",
      fontSize: "1.6rem",
      height: "28px",
      value: selectedSubListItem.value,
      onUpdate: _cache[1] || (_cache[1] = (item)=>{changeSub(item);})
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subList.value, (ele) => {
          return (_openBlock(), _createElementBlock("option", {
            value: ele.key,
            key: ele.key
          }, _toDisplayString(ele.text), 9, _hoisted_3))
        }), 128))
      ]),
      _: 1
    }, 8, ["value"]), [
      [_vShow, subList.value.length >= 2]
    ]),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_7)
                ]),
                _hoisted_8
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_9)
                ]),
                _hoisted_10
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_11)
                ]),
                _hoisted_12
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_13)
                ]),
                _hoisted_14
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_15)
                ]),
                _hoisted_16
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_17)
                ]),
                _hoisted_18
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_19)
                ]),
                _hoisted_20
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[1].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("table", _hoisted_23, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_24)
                ]),
                _hoisted_25
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_26)
                ]),
                _hoisted_27
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_28)
                ]),
                _hoisted_29
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_30)
                ]),
                _hoisted_31
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_32)
                ]),
                _hoisted_33
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_34)
                ]),
                _hoisted_35
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_36)
                ]),
                _hoisted_37
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[2].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("table", _hoisted_40, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_41)
                ]),
                _hoisted_42
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_43)
                ]),
                _hoisted_44
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_45)
                ]),
                _hoisted_46
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_47)
                ]),
                _hoisted_48
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_49)
                ]),
                _hoisted_50
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_51)
                ]),
                _hoisted_52
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_53)
                ]),
                _hoisted_54
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[3].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("table", _hoisted_57, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_58)
                ]),
                _hoisted_59
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_60)
                ]),
                _hoisted_61
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_62)
                ]),
                _hoisted_63
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_64)
                ]),
                _hoisted_65
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_66)
                ]),
                _hoisted_67
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_68)
                ]),
                _hoisted_69
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_70)
                ]),
                _hoisted_71
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[4].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
          _hoisted_73,
          _createElementVNode("table", _hoisted_74, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_75)
                ]),
                _hoisted_76
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_77)
                ]),
                _hoisted_78
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_79)
                ]),
                _hoisted_80
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_81)
                ]),
                _hoisted_82
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_83)
                ]),
                _hoisted_84
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_85)
                ]),
                _hoisted_86
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_87)
                ]),
                _hoisted_88
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[5].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
          _hoisted_90,
          _createElementVNode("table", _hoisted_91, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_92)
                ]),
                _hoisted_93
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_94)
                ]),
                _hoisted_95
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_96)
                ]),
                _hoisted_97
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_98)
                ]),
                _hoisted_99
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_100)
                ]),
                _hoisted_101
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_102)
                ]),
                _hoisted_103
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_104)
                ]),
                _hoisted_105
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_GENERAL_TRAFFIC[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
          _hoisted_107,
          _createElementVNode("table", _hoisted_108, [
            _createElementVNode("tbody", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(GEN_LOCATION_ROAD_TYPE, (item) => {
                return _createElementVNode("tr", {
                  key: item.text
                }, [
                  _createElementVNode("th", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["legend-list__line_gen", item.style])
                    }, null, 2)
                  ]),
                  _createElementVNode("th", _hoisted_109, _toDisplayString(item.text), 1)
                ])
              }), 64))
            ])
          ]),
          _hoisted_110,
          _createElementVNode("table", _hoisted_111, [
            _createElementVNode("tbody", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(GEN_LOCATION_LANES, (item) => {
                return _createElementVNode("tr", {
                  key: item.text
                }, [
                  _createElementVNode("th", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["legend-list__line_gen", item.style])
                    }, null, 2)
                  ]),
                  _createElementVNode("th", null, _toDisplayString(item.text), 1)
                ])
              }), 64))
            ])
          ]),
          _hoisted_112,
          _createElementVNode("table", _hoisted_113, [
            _createElementVNode("tbody", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(GEN_LOCATION_HOURS, (item) => {
                return _createElementVNode("tr", {
                  key: item.text.replace('hh', '12')
                }, [
                  _createElementVNode("th", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["legend-list__line_gen", item.style])
                    }, null, 2)
                  ]),
                  _createElementVNode("th", null, _toDisplayString(item.text.replace("hh", "12")), 1)
                ])
              }), 64))
            ])
          ]),
          _hoisted_114,
          _createElementVNode("table", _hoisted_115, [
            _createElementVNode("tbody", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(GEN_LOCATION_HOURS, (item) => {
                return _createElementVNode("tr", {
                  key: item.text.replace('hh', '24')
                }, [
                  _createElementVNode("th", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["legend-list__line_gen", item.style])
                    }, null, 2)
                  ]),
                  _createElementVNode("th", null, _toDisplayString(item.text.replace("hh", "24")), 1)
                ])
              }), 64))
            ])
          ]),
          _hoisted_116,
          _createElementVNode("table", _hoisted_117, [
            _createElementVNode("tbody", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(GEN_LOCATION_CONGESTION, (item) => {
                return _createElementVNode("tr", {
                  key: item.text
                }, [
                  _createElementVNode("th", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["legend-list__line_gen", item.style])
                    }, null, 2)
                  ]),
                  _createElementVNode("th", null, _toDisplayString(item.text), 1)
                ])
              }), 64))
            ])
          ]),
          _hoisted_118,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(GEN_LOCATION_TRAVEL, (table) => {
            return _createElementVNode("table", {
              key: table.title,
              class: "legend-list__group-table",
              border: "10",
              frame: "box",
              rules: "none"
            }, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.items, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.text
                  }, [
                    _createElementVNode("th", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["legend-list__line_gen", item.style])
                      }, null, 2)
                    ]),
                    _createElementVNode("th", null, _toDisplayString(item.text), 1)
                  ]))
                }), 128))
              ])
            ])
          }), 64))
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_GENERAL_TRAFFIC[1].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
          _hoisted_120,
          _createElementVNode("table", _hoisted_121, [
            _createElementVNode("tbody", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(GEN_TIME, (item) => {
                return _createElementVNode("tr", {
                  key: item.text
                }, [
                  _createElementVNode("th", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass(item.style)
                    }, null, 2)
                  ]),
                  _createElementVNode("th", null, _toDisplayString(item.text), 1)
                ])
              }), 64))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_ETC[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
          _createElementVNode("div", _hoisted_123, [
            _createTextVNode(" ・高速道路 "),
            _createVNode(_unref(Tooltip), {
              direction: "text",
              class: "help-tooltip",
              tooltipId: "etcExpressway",
              id: "tooltipImage-etcExpressway"
            }, {
              label: _withCtx(() => [
                _createElementVNode("img", {
                  src: _unref(QuestionIcon),
                  class: "help-icon"
                }, null, 8, _hoisted_124)
              ]),
              content: _withCtx(() => [
                _hoisted_125
              ]),
              _: 1
            })
          ]),
          _hoisted_126,
          _createElementVNode("div", _hoisted_127, [
            _createTextVNode(" ・都市高速道路 "),
            _createVNode(_unref(Tooltip), {
              direction: "text",
              class: "help-tooltip",
              tooltipId: "etcCityExpressway",
              id: "tooltipImage-etcCityExpressway"
            }, {
              label: _withCtx(() => [
                _createElementVNode("img", {
                  src: _unref(QuestionIcon),
                  class: "help-icon"
                }, null, 8, _hoisted_128)
              ]),
              content: _withCtx(() => [
                _hoisted_129
              ]),
              _: 1
            })
          ]),
          _hoisted_130,
          _createElementVNode("div", _hoisted_131, [
            _createTextVNode(" ・一般道路 "),
            _hoisted_132,
            _createTextVNode("（一般国道、都道府県など） "),
            _createVNode(_unref(Tooltip), {
              direction: "text",
              class: "help-tooltip",
              tooltipId: "etcWay",
              id: "tooltipImage-etcWay"
            }, {
              label: _withCtx(() => [
                _createElementVNode("img", {
                  src: _unref(QuestionIcon),
                  class: "help-icon"
                }, null, 8, _hoisted_133)
              ]),
              content: _withCtx(() => [
                _hoisted_134
              ]),
              _: 1
            })
          ]),
          _hoisted_135
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_ETC[1].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_136, _hoisted_143))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_OD[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
          _hoisted_145,
          _createElementVNode("table", _hoisted_146, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(odPointDepartureLayerIcon) }, null, 8, _hoisted_147)
                ]),
                _hoisted_148
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(odPointArrivalLayerIcon) }, null, 8, _hoisted_149)
                ]),
                _hoisted_150
              ])
            ])
          ]),
          _hoisted_151,
          _hoisted_152,
          _hoisted_153,
          _hoisted_154
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_OD[1].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
          _hoisted_156,
          _createElementVNode("table", _hoisted_157, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(odPointGenerationLayerIcon) }, null, 8, _hoisted_158)
                ]),
                _hoisted_159
              ])
            ])
          ]),
          _hoisted_160,
          _hoisted_161
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_ROAD_STRUCTURES[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
          _hoisted_163,
          _createElementVNode("table", _hoisted_164, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(BridgesLayerIcon) }, null, 8, _hoisted_165)
                ]),
                _hoisted_166
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(TunnelsLayerIcon) }, null, 8, _hoisted_167)
                ]),
                _hoisted_168
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(ShedsLayerIcon) }, null, 8, _hoisted_169)
                ]),
                _hoisted_170
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(CulvertsLayerIcon) }, null, 8, _hoisted_171)
                ]),
                _hoisted_172
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(PedestrianDecksLayerIcon) }, null, 8, _hoisted_173)
                ]),
                _hoisted_174
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(OverheadSignagesLayerIcon) }, null, 8, _hoisted_175)
                ]),
                _hoisted_176
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(PavementsLayerIcon) }, null, 8, _hoisted_177)
                ]),
                _hoisted_178
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(EarthworksLayerIcon) }, null, 8, _hoisted_179)
                ]),
                _hoisted_180
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_ACCIDENT_HOTSPOT[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_181, _hoisted_184))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_ROADKILL[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
          _hoisted_186,
          _createElementVNode("table", _hoisted_187, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(loadkillOccurrenceLayerIcon) }, null, 8, _hoisted_188)
                ]),
                _hoisted_189
              ]),
              _hoisted_190
            ])
          ]),
          _hoisted_191,
          _createElementVNode("table", _hoisted_192, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(loadkillWarningSignLayerIcon) }, null, 8, _hoisted_193)
                ]),
                _hoisted_194
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(loadkillRoadMarkingLayerIcon) }, null, 8, _hoisted_195)
                ]),
                _hoisted_196
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(loadkillUnderpassLayerIcon) }, null, 8, _hoisted_197)
                ]),
                _hoisted_198
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(loadkillSignboardLayerIcon) }, null, 8, _hoisted_199)
                ]),
                _hoisted_200
              ]),
              _hoisted_201,
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(loadkillInformationBoardLayerIcon) }, null, 8, _hoisted_202)
                ]),
                _hoisted_203
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(loadkillPortableSignLayerIcon) }, null, 8, _hoisted_204)
                ]),
                _hoisted_205
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(loadkillOtherLayerIcon) }, null, 8, _hoisted_206)
                ]),
                _hoisted_207
              ]),
              _hoisted_208
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_SPECIFIC_SITUATIONS[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_209, [
          _hoisted_210,
          _createElementVNode("table", _hoisted_211, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(majorTrafficCongestionLayerIcon) }, null, 8, _hoisted_212)
                ]),
                _hoisted_213
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_SPECIFIC_SITUATIONS[1].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
          _hoisted_215,
          _createElementVNode("table", _hoisted_216, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(RoadtypeLogisticsLayerIcon) }, null, 8, _hoisted_217)
                ]),
                _hoisted_218
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(RoadtypeAlternativeLayerIcon) }, null, 8, _hoisted_219)
                ]),
                _hoisted_220
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_SPECIFIC_SITUATIONS[2].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
          _hoisted_222,
          _hoisted_223,
          _hoisted_224,
          _hoisted_225,
          _hoisted_226,
          _hoisted_227,
          _hoisted_228,
          _hoisted_229,
          _hoisted_230,
          _hoisted_231,
          _hoisted_232,
          _hoisted_233,
          _createElementVNode("table", _hoisted_234, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(specialVehicleXpointConditionCLayerIcon) }, null, 8, _hoisted_235)
                ]),
                _hoisted_236
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(specialVehicleXpointExemptLayerIcon) }, null, 8, _hoisted_237)
                ]),
                _hoisted_238
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_DRM[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
          _hoisted_240,
          _hoisted_241,
          _hoisted_242,
          _createElementVNode("table", _hoisted_243, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_244)
                ]),
                _hoisted_245
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_DRM[1].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
          _hoisted_247,
          _hoisted_248,
          _hoisted_249,
          _createElementVNode("table", _hoisted_250, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_251)
                ]),
                _hoisted_252
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})